



















import Vue from "vue";
import { Component } from 'vue-property-decorator'
@Component
    export default  class FooterComponent extends Vue{
        constructor() {
    super();
     //console.log("FooterComponent created");
  }
    }
